
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import * as ReactRouterDOM from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import { isBrowser } from 'react-device-detect';
import { Interweave } from "interweave";
import { ReactSocialMediaIcons } from 'react-social-media-icons';
import { Helmet } from "react-helmet";


const AboutUs = () => {

    //#region Const 
    // const navigate = ReactRouterDOM.useNavigate();

    const toaster = rsuite.useToaster();

    const [Comment, setComment] = React.useState();
    const [Title, setTitle] = React.useState("");
    const [Address, setAddress] = React.useState("");
    const [Tel1, setTel1] = React.useState("");
    const [Tel2, setTel2] = React.useState("");
    const [Mobile, setMobile] = React.useState("");
    const [Email, setEmail] = React.useState("");
    const [Watsapp, setWatsapp] = React.useState("");
    const [Instagram, setInstagram] = React.useState("");
    const [Telegram, setTelegram] = React.useState("");
    const [Lon, setLon] = React.useState("");
    const [Lat, setLat] = React.useState("");
    const [background, setbackground] = React.useState("");



    const Get = () => {
        fetch(General.ApiRoute() + '/AboutUs/GetForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                setComment(result.comment);
                setTitle(result.title);
                setAddress(result.address);
                setTel1(result.tel1);
                setTel2(result.tel2);
                setMobile(result.mobile);
                setEmail(result.email);
                setWatsapp(result.watsapp);
                setInstagram(result.instagram);
                setTelegram(result.telegram);
                setLat(result.lat);
                setLon(result.lon);
                // setbackground("");
            })

    }



    //#endregion
    React.useEffect(() => {
        Get()
        document.title = "درباره ما";
    }, [])


    return (
        <Layout>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                <meta
                    name="description"
                    content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                />
            </Helmet >
            <div className="ProductInfoBanner">
                درباره ما
            </div>

            <h1 className="ProductInfoAddressBar mb-0">
                <rsuite.Breadcrumb >
                    <rsuite.Breadcrumb.Item style={{ fontSize: "13px" }} href="/">
                        خانه
                    </rsuite.Breadcrumb.Item>
                    <rsuite.Breadcrumb.Item style={{ color: '#3b6682', fontSize: "13px" }}>درباره ما</rsuite.Breadcrumb.Item>
                </rsuite.Breadcrumb>

            </h1>
            <rsuite.Image src="../../../../assets/images/Store.jpg" style={{ height: '70vh', backgroundSize: 'cover' }} />

            <div className={isBrowser ? "AboutUs-text" : "AboutUs-text-Mobile"}>
                <rsuite.Row className="justify-content-center align-items-center">
                    <rsuite.Col xs={24}>
                        <p >
                            <Interweave content={Comment} />
                        </p>
                        <p className="text-center mt-0 pt-0">
                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="instagram"
                                iconColor="rgb(230, 13, 13)" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url="https://www.instagram.com/farm.asan?igsh=Nzd5d3dyNWY2MzJz" size="40" />

                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="whatsapp"
                                iconColor="rgb(16, 107, 29)" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url="https://wa.me/+989101172004" size="40" />

                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="map"
                                iconColor="rgb(16, 77, 143)" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url="https://maps.app.goo.gl/1vqVsQ67XDTQKxSF9" size="40" />

                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="mail"
                                iconColor="rgb(34, 38, 41)" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url="https://mail.google.com/mail/?view=cm&fs=1&to=Asma.dehghani@gmail.com" size="40" />




                        </p>
                    </rsuite.Col>

                </rsuite.Row>
            </div>

            {/* <rsuite.Row>
                <rsuite.Col xs={12} xsHidden smHidden>
                </rsuite.Col>
                <rsuite.Col md={12} xsHidden smHidden className="h-30vh">
                    <rsuite.Row>
                        <rsuite.Col xs={10} className="p-4" > <div className="h-20vh text-center shadow-sm FarmAsan-bg-Shadow  rounded">
                            <BiIcon.BiSolidBasket className='FarmAsan-text Font25  mt-3'/>
                        </div></rsuite.Col>
                        <rsuite.Col xs={10} className="p-4" > <div className="h-20vh shadow-sm FarmAsan-bg-Shadow  rounded"></div></rsuite.Col>
                        <rsuite.Col xs={4} ></rsuite.Col>
                    </rsuite.Row>

                </rsuite.Col>
            </rsuite.Row> */}



        </Layout >
    )
}

export default AboutUs;